import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import UILoadingDots from 'UIComponents/loading/UILoadingDots';
import InpageSectionSearchResultsContainer from '../sections/InpageSectionSearchResultsContainer';
import InpageNoSavedSectionsMessage from '../sections/InpageNoSavedSectionsMessage';
import { getSidebarSearchQuery } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { getAddableSections, getAddableEmbeds } from 'ContentEditorUI/redux/selectors/templateInfoSelectors';
import MobileSidebarOverlayContainer from 'ContentEditorUI/components/sidebar/MobileSidebarOverlayContainer';
import InpageSectionsContainer from '../sections/InpageSectionsContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// If we're rendering this component, then we know that the user _could_ have custom sections
// So, we can get away with a null (or undefined) check here to check request status so we don't have
// to add redux-request-state as a dep
const getSectionsRequestIsPending = state => {
  const addableSections = getAddableSections(state);
  return addableSections == null;
};
const getHasSections = state => {
  const addableSections = getAddableSections(state);
  const addableEmbeds = getAddableEmbeds(state);
  return addableSections.length > 0 || addableEmbeds.length > 0;
};
const PatagoniaInpageAddSectionContainer = ({
  onDragStart,
  onDragEnd,
  sidebarSearchResultsMap
}) => {
  const isSectionsRequestPending = useSelector(getSectionsRequestIsPending);
  const hasSections = useSelector(getHasSections);
  const categorizedSearchQuery = useSelector(getSidebarSearchQuery);
  if (isSectionsRequestPending) {
    return /*#__PURE__*/_jsx(UILoadingDots, {
      className: "m-top-8"
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    className: "m-all-5",
    children: [/*#__PURE__*/_jsx(MobileSidebarOverlayContainer, {
      modalMessageKey: "addModule.mobile.message.addSection",
      contextual: false
    }), !hasSections && /*#__PURE__*/_jsx(InpageNoSavedSectionsMessage, {}), hasSections && /*#__PURE__*/_jsxs(_Fragment, {
      children: [categorizedSearchQuery && /*#__PURE__*/_jsx(InpageSectionSearchResultsContainer, {
        onDragStart: onDragStart,
        onDragEnd: onDragEnd,
        sidebarSearchResultsMap: sidebarSearchResultsMap,
        searchQuery: categorizedSearchQuery
      }), !categorizedSearchQuery && /*#__PURE__*/_jsx(InpageSectionsContainer, {
        onDragStart: onDragStart,
        onDragEnd: onDragEnd
      })]
    })]
  });
};
PatagoniaInpageAddSectionContainer.propTypes = {
  onDragStart: PropTypes.func.isRequired,
  onDragEnd: PropTypes.func.isRequired,
  sidebarSearchResultsMap: PropTypes.object
};
export default PatagoniaInpageAddSectionContainer;